import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Row } from "react-bootstrap";
import moment from "moment";
import Translation from "i18next";
import { AirportFullName } from "../../../service/shared/AirportFullName";
class FlightSelectionSummaryDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetail: false,
    };
  }
  toggleFlightDetail = () => {
    this.setState({ showDetail: !this.state.showDetail });
  };
  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let time = moment(dateString)
      .locale(localStorage.getItem("i18nextLng"))
      .format("LT");

    let newDate = moment(dateString)
      .locale(localStorage.getItem("i18nextLng"))
      .format("DD MMMM YYYY");
    return (
      <span>
        {newDate} {time}{" "}
      </span>
    );
  };
  renderStops(segments, stops, key) {
    if (stops > 0) {
      if (segments.length > 1) {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
          </span>
        );
      } else {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
            {segments.map((segment, index) => (
              <span key={index}>
                {segment.flight.stopAirports.map((airport, index2) => (
                  <span key={index2}>{airport.airport}</span>
                ))}
              </span>
            ))}
          </span>
        );
      }
    } else {
      return <span>{Translation.t("non-stop")}</span>;
    }
  }
  renderAirportName(airportCode) {
    let airportName = AirportFullName.getFullName(airportCode);
    return <span>{airportName}</span>;
  }

  render() {
    return (
      <div>
        <Button
          className="selected-flight-detail-btn mb-1"
          onClick={() => this.toggleFlightDetail()}
        >
          <span>{Translation.t("details")}</span>
          <span className="px-2">
            <FontAwesomeIcon
              icon={this.state.showDetail ? faCaretUp : faCaretDown}
            />
          </span>
        </Button>
        {this.state.showDetail && (
          <div className="segment-info">
            <Row className="segment-info-detail">
              {this.props.itineraryPart.segments.map((segment, index) => (
                <Col xs={12} className="mb-5 mt-4 segment-info-col ">
                  <div className="segment-line"></div>
                  {segment.origin != null && (
                    <div className="pb-2 segment-info-origin">
                      <span className="segment-info-airportcode">
                        {segment.origin}
                      </span>{" "}
                      <span className="segment-info segment-info-airport-name">
                        {this.renderAirportName(segment.origin)}
                      </span>
                    </div>
                  )}
                  {segment.duration != null && (
                    <div className="segment-info-date py-1">
                      <span className="pr-3">
                        {this.parseDate(segment.departure)}
                      </span>
                      <span></span>
                    </div>
                  )}

                  <div className="py-1 pt-3">
                    {segment.flight.airlineCode === "ET" && (
                      <img
                        className="custom-img-sm-flag"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQxOEVGQjY5MkU2RDExRTg5OUJEOUMzMUY3ODM2MzRBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQxOEVGQjZBMkU2RDExRTg5OUJEOUMzMUY3ODM2MzRBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDE4RUZCNjcyRTZEMTFFODk5QkQ5QzMxRjc4MzYzNEEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDE4RUZCNjgyRTZEMTFFODk5QkQ5QzMxRjc4MzYzNEEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6v0jrNAAADT0lEQVR42mL8//8/Ay0B45C3gIkWhh69vi9nZvT8PVNoYsH+yzvm7p707efXk7cOU98CoOmL98+AsH/9+QkkWaho+vaz61cfXQjnCvIIU9OCTadWbjixHFlEQUyFOhb8Z/i/8vD8Xec3oYkbKJpSwYJ///8t3Dvt8LU9aOKszGwGSmaUWgCMxmnbui49OIsp5WkcyMvJR5EFn79/mrCp+f7L25hSpqrWfubhFOXklx+e9W9qfvXhOXrBwMAIdHuQVQwTIxP5Flx/cmna1q6vP7+giYvwiSe75qlLa1NUFh24snPJgVn//v1FFmRmYgY63Edble31FAZBXwahMLgUC0kJBpgcd1/YjJ4clczCzD0lvkxjuJUJ4nPpk+ODj9/ez9zRe+PJFWRBWRGFCJsoTeadDC8nMfz7ATaPmUHnIgO7PGk+uPXs2vTt3R+/voeL8HMLBpqH2orcZXwRyvDnHUKpaBKy6YR9AMylu85tApYwwPCBiPBw8HoZBzhJvWF71c3w+yWKag5lBq2jDEzcxFrw9ceX+Xsnn7t7EqqdjdPNwNdD/gfH626GX0/QVTPzMWjsYeDUJLZGu/Hk8uxdE95/eQvJ9876Hp5KjLxv+xl+3seiGmiu0kJM07Fb8Pvvr/XHl+08txEYPuysHM567q5yP/g/TMduNJcug2gqg0gsAyMLUXXyg1d3Zu+c8Pz9Ey52bld9dxfpd9zvZ2IJEE4tBqGgH5+M3u1/+PHgET4rc+ncTKwWIKz9+fvH+hPLgMmcl4MvxDzASfwOx/sqhpcfkRzDzsBr9Z/L4fNdqfdb7384ePDnk2UQGV4LUwKtiksPzgDzJzBAXDW0LfhPs31cx/D/N7R04dT6z2P7863K+3P/Px298On02f+/fiEbwS4tpbNpNTMvD3YLXn54DkyFTP9/28sxajJtYvx+jYGJk4Hb6B+byfeXYh/P/vl4/OrXS5f//fiJVT8zD7fWikWcaio4fXD5YpsCxwPu/y/+/hT/+U74233Wjxe+fL184+eTpwQzINDtqjMncampEm54vdmw+deLl3/ef/j97t3fD5/+fPjw58NHIPn/z9+/X7+iaGBmYhESYpeRFnRzFosMZebiGu5Nx6FvAUCAAQB0q4lEc87klQAAAABJRU5ErkJggg=="
                      />
                    )}
                    <span className="pr-1 ">{segment.flight.airlineCode}</span>
                    {segment.flight.flightNumber != null && (
                      <span>{segment.flight.flightNumber}</span>
                    )}{" "}
                    {segment.flight.operatingAirlineCode != null && (
                      <span>
                        {Translation.t("operated_by")}{" "}
                        {segment.flight.operatingAirlineCode}
                      </span>
                    )}
                  </div>
                  {segment.duration != null &&
                    segment.manufacturerName != null && (
                      <div className="py-1">
                        Aircraft: {segment.manufacturerName}{" "}
                        {segment.equipmentDescription}
                      </div>
                    )}
                  {segment.departureTerminal != null && (
                    <div className="py-1">
                      {Translation.t("departure")}{" "}
                      {segment.flight.departureTerminal}
                    </div>
                  )}
                  {segment.arrivalTerminal != null && (
                    <div className="py-1">
                      {Translation.t("arrival")}{" "}
                      {segment.flight.arrivalTerminal}
                    </div>
                  )}
                  <div className="segment-info-destination">
                    {segment.arrival != null && (
                      <div className="py-1 segment-info-date">
                        {this.parseDate(segment.arrival)}{" "}
                      </div>
                    )}
                    {segment.destination != null && (
                      <div className="py-1">
                        <span className="segment-info-airportcode">
                          {segment.destination}
                        </span>{" "}
                        <span className="segment-info segment-info-airport-name">
                          {this.renderAirportName(segment.destination)}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="segment-line"></div>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
    );
  }
}
export default FlightSelectionSummaryDetail;
